const getLocalStorage = async (key) => {
    try {
        const item = localStorage.getItem(key);
        return item !== null ? JSON.parse(item) : null;
    } catch (error) {
        console.error(`Error getting item from localStorage: ${error}`);
        return null;
    }
}

const setLocalStorage = async (key, value) => {
    try {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
    } catch (error) {
        console.error(`Error setting item in localStorage: ${error}`);
    }
}


export {
    getLocalStorage, setLocalStorage
}